// src/components/ResellerRegistration.js
import React, { useState } from 'react';
import { auth, createUserWithEmailAndPassword } from '../../firebase'; // Importar auth y la función de registro

const ResellerRegistration = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación de los campos
    if (email === '' || password === '') {
      setError('Por favor ingresa tu correo y contraseña.');
      return;
    }

    setLoading(true); // Deshabilitar el botón mientras se procesa el registro
    setError(''); // Resetear el mensaje de error

    try {
      // Crear el usuario con email y contraseña en Firebase
      await createUserWithEmailAndPassword(auth, email, password);
      // Si el registro es exitoso, redirigir al login
      window.location.href = '/reseller-login';
    } catch (error) {
      setError('Error al crear la cuenta: ' + error.message); // Mostrar el mensaje de error
    } finally {
      setLoading(false); // Reactivar el botón
    }
  };

  return (
    <div className="registration-container">
      <h2>Registro de Revendedor</h2>
      {error && <p className="error-message">{error}</p>}  {/* Mostrar mensaje de error si existe */}
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)} // Actualizar el estado del email
            required
          />
        </div>
        <div>
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)} // Actualizar el estado de la contraseña
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Registrando...' : 'Registrar'}  {/* Cambiar el texto del botón mientras carga */}
        </button>
      </form>
    </div>
  );
};

export default ResellerRegistration;
